/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-06 19:31:06
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 12:22:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/slice/index.ts
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import {
  generateDefaultState as _generateDefaultState,
  //hasError,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import { getStateTarget as getTarget } from 'src/tools/helper';

import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  moduleContentDynamicOnChange as _moduleContentDynamicOnChange,
  moduleContentOnChange as _moduleContentOnChange,
  moduleContentStaticOnChange as _moduleContentStaticOnChange,
} from 'src/constrains/DraggableModules/reduxFunctions';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  EnumCollapseId,
  fixedCollapse,
  generateDefaultFlashSaleBarStyle,
  generateDefaultFont,
  generateDefaultNavigationBar,
  generateDefaultPrimaryCallToActionButtonStyle,
  generateDefaultProductDetailsPageTabBarStyle,
  generateDefaultSecondaryCallToActionButtonStyle,
  generateDefaultTopLeaderBoardBanner,
  generateRemainingStockTextStyle,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
import { convertDataFromServerToRedux } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/tools';
import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseStatus as _getCollapseStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getHasModified as _getHasModified,
  getLoaded as _getLoaded,
  getOpeningCollapse2 as _getOpeningCollapse2,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getState as _getState,
  getSubmitStamp as _getSubmitStamp,
  getReducer,
} from 'src/pages/SalesChannelContentEditor/slice/selectors';
import {
  getAppearance,
  postAppearance,
} from 'src/request/salesChannel/content';
import { msg } from 'src/tools/message';

export const fetchContentAppearance = createAsyncThunk(
  'fetchSalesChannelContentAppearance',
  async (data: any) => {
    const { uuid, params = {}, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getAppearance(uuid, params);
    return { response, isPrimary, isClone };
  },
);

export const submitContentAppearance = createAsyncThunk(
  'submitSalesChannelContentAppearance',
  async ({ body, params }: any) => {
    const { uuid } = body;
    const isPrimary = isCurrentPrimary();
    const response = await postAppearance(body, params);
    return { response, isNew: !!!uuid, isPrimary };
  },
);
//import _ from 'lodash';
export { EnumCollapseId };
const _defaultContent = {
  topLeaderBoardBanner: generateDefaultTopLeaderBoardBanner(),
  enableRemainingStockTextStyle: false,
  productDetailsPageTabBarStyle: generateDefaultProductDetailsPageTabBarStyle(),
  flashSaleBarStyle: generateDefaultFlashSaleBarStyle(),
  primaryCallToActionButtonStyle:
    generateDefaultPrimaryCallToActionButtonStyle(),
  secondaryCallToActionButtonStyle:
    generateDefaultSecondaryCallToActionButtonStyle(),
  remainingStockTextStyle: generateRemainingStockTextStyle(),
  font: generateDefaultFont(),
  miniProgramNavBar: generateDefaultNavigationBar(),
};
const _defaultState = _generateDefaultState(fixedCollapse, _defaultContent);

const defaultState = {
  ..._defaultState,
  ...defaultStatus,
};

const salesChannelContentAppearance = createSlice({
  name: 'salesChannelContentAppearance',
  initialState: defaultState,
  reducers: {
    moduleContentOnChange(state, action) {
      _moduleContentOnChange(state, action);
    },
    moduleContentStaticOnChange(state, action) {
      _moduleContentStaticOnChange(state, action);
    },
    moduleContentDynamicOnChange(state, action) {
      _moduleContentDynamicOnChange(state, action);
    },

    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },
    onTabBarStyleChange(state, action) {
      const { key, data, soldOut } = action.payload;
      state.hasModified = true;
      state.productDetailsPageTabBarStyle.soldOutFlag = soldOut;
      state.productDetailsPageTabBarStyle[key] = {
        ...state.productDetailsPageTabBarStyle[key],
        ...data,
      };
    },

    onTabBarStyleReset(state) {
      state.hasModified = true;
      state.productDetailsPageTabBarStyle =
        generateDefaultProductDetailsPageTabBarStyle();
    },

    onFlashSaleBarStyleChange(state, action) {
      const { key, data, saleNow } = action.payload;
      state.hasModified = true;
      state.flashSaleBarStyle.saleNow = saleNow;
      state.flashSaleBarStyle[key] = {
        ...state.flashSaleBarStyle[key],
        ...data,
      };
    },

    onFlashSaleBarStyleReset(state) {
      state.hasModified = true;
      state.flashSaleBarStyle = generateDefaultFlashSaleBarStyle();
    },
    ongRemainingStockTextStyleChange(state, action) {
      state.hasModified = true;
      state.remainingStockTextStyle = action.payload;
    },
    onRemainingStockTextStyleReset(state) {
      state.hasModified = true;
      state.remainingStockTextStyle = generateRemainingStockTextStyle();
    },

    onTopLeaderBoardBannerChange(state, action) {
      state.hasModified = true;
      state.topLeaderBoardBanner.link = {
        ...state.topLeaderBoardBanner.link,
        ...action.payload,
      };
    },

    onLoadingAnimationChange(state, action) {
      state.hasModified = true;
      state.loadingAnimation = action.payload;
    },

    onPrimaryActionButtonStyleChange(state, action) {
      state.hasModified = true;
      state.primaryCallToActionButtonStyle = {
        ...state.primaryCallToActionButtonStyle,
        ...action.payload,
      };
    },

    onPrimaryActionButtonStyleReset(state) {
      state.hasModified = true;
      state.primaryCallToActionButtonStyle =
        generateDefaultPrimaryCallToActionButtonStyle();
    },

    onSecondaryActionButtonStyleChange(state, action) {
      state.hasModified = true;
      state.secondaryCallToActionButtonStyle = {
        ...state.secondaryCallToActionButtonStyle,
        ...action.payload,
      };
    },
    onSecondaryActionButtonStyleReset(state) {
      state.hasModified = true;
      state.secondaryCallToActionButtonStyle =
        generateDefaultSecondaryCallToActionButtonStyle();
    },

    onMiniProgramNavigationBarChange(state, action) {
      state.hasModified = true;
      state.miniProgramNavBar = {
        ...state.miniProgramNavBar,
        ...action.payload,
      };
    },
    onMiniProgramNavigationBarReset(state) {
      state.hasModified = true;
      state.miniProgramNavBar = generateDefaultNavigationBar();
    },
    onFontChange(state, action) {
      state.hasModified = true;
      console.log(action.payload, 'action.payload');
      state.font = {
        ...state.font,
        ...action.payload,
      };
    },
    onFloatingActionButtonStyle(state, action) {
      state.hasModified = true;
      state.floatingActionButtonStyle = {
        ...state.floatingActionButtonStyle,
        ...action.payload,
      };
    },
    onFloatingActionButtonStyleReset(state) {
      state.hasModified = true;
      state.floatingActionButtonStyle = generateDefaultFlashSaleBarStyle();
    },
    onFontReset(state) {
      state.hasModified = true;
      state.font = generateDefaultFont();
    },

    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    resetData(state) {
      assData(state, defaultState);
    },
    validation(state) {
      state.isDataValid = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContentAppearance.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(fetchContentAppearance.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(fetchContentAppearance.fulfilled, (state, action) => {
      const { response, isClone } = action.payload;
      const _data = convertDataFromServerToRedux(response) || {};

      assData(state, _data);
      if (isClone) state.hasModified = true;
    });
    builder.addCase(submitContentAppearance.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(submitContentAppearance.rejected, (state) => {
      state.loaded = true;
    });
    builder.addCase(submitContentAppearance.fulfilled, (state, action) => {
      const { response } = action.payload;
      const _data: any = convertDataFromServerToRedux(response) || {};
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      assData(state, { ..._data });
    });
  },
});

export const {
  resetData,
  onCollapseOpen,
  onErrorChange,
  onTabBarStyleChange,
  onFlashSaleBarStyleChange,
  onFlashSaleBarStyleReset,
  onPrimaryActionButtonStyleChange,
  ongRemainingStockTextStyleChange,
  onSecondaryActionButtonStyleChange,
  onFontChange,
  onTabBarStyleReset,
  onRemainingStockTextStyleReset,
  onPrimaryActionButtonStyleReset,
  onSecondaryActionButtonStyleReset,
  onFontReset,
  validation,
  onLoadingAnimationChange,
  onTopLeaderBoardBannerChange,
  onMiniProgramNavigationBarChange,
  onMiniProgramNavigationBarReset,
  onFloatingActionButtonStyle,
  onFloatingActionButtonStyleReset,
} = salesChannelContentAppearance.actions;

export const getTabBarStyle = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance))
        .productDetailsPageTabBarStyle,
    (productDetailsPageTabBarStyle) => {
      return productDetailsPageTabBarStyle;
    },
  );
};

export const getFlashSaleBarStyle = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance)).flashSaleBarStyle,
    (flashSaleBarStyle) => {
      return flashSaleBarStyle;
    },
  );
};

export const getRemainingStockTextStyle = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance))
        .remainingStockTextStyle,
    (remainingStockTextStyle) => {
      return remainingStockTextStyle;
    },
  );
};
export const getPrimaryActionButtonStyle = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance))
        .primaryCallToActionButtonStyle,
    (primaryCallToActionButtonStyle) => {
      return primaryCallToActionButtonStyle;
    },
  );
};
export const getMiniProgramNavigationBarButtonStyle = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance)).miniProgramNavBar,
    (miniProgramNavBar) => {
      return miniProgramNavBar;
    },
  );
};

export const getTopLeaderBoardBanner = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance))
        .topLeaderBoardBanner,
    (topLeaderBoardBanner) => {
      return topLeaderBoardBanner;
    },
  );
};

export const getFloatingActionButtonStyle = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance))
        .floatingActionButtonStyle,
    (floatingActionButtonStyle) => {
      return floatingActionButtonStyle;
    },
  );
};

export const getLoadingAnimation = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance)).loadingAnimation,
    (loadingAnimation) => {
      return loadingAnimation;
    },
  );
};

export const getSecondaryActionButtonStyle = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance))
        .secondaryCallToActionButtonStyle,
    (secondaryCallToActionButtonStyle) => {
      return secondaryCallToActionButtonStyle;
    },
  );
};

export const getFont = () => {
  return createSelector(
    (state: any) => getTarget(state, getReducer(EnumReducers.appearance)).font,
    (font) => {
      return font;
    },
  );
};
export const getShowRemainingStock = () => {
  return createSelector(
    (state: any) =>
      getTarget(state, getReducer(EnumReducers.appearance))
        .enableRemainingStockTextStyle,
    (enableRemainingStockTextStyle) => {
      return enableRemainingStockTextStyle;
    },
  );
};

export const getLoaded = () => {
  return _getLoaded(EnumReducers.appearance);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.appearance);
};

export const getOpeningCollapse2 = () => {
  return _getOpeningCollapse2(EnumReducers.appearance);
};
export const getState = () => {
  return _getState(EnumReducers.appearance);
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.appearance);
};

export const getCollapseStatus = (id) => {
  return _getCollapseStatus(EnumReducers.appearance, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.appearance, id);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.appearance);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.appearance);
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.appearance, id);
};

export default salesChannelContentAppearance.reducer;
